import { CursorClick, TrendUp, ShieldWarning, Bell } from '@phosphor-icons/react';

const typeConfig = {
  new_click: { icon: CursorClick, color: 'text-blue-400', bg: 'bg-blue-500/10', label: 'Click' },
  new_conversion: { icon: TrendUp, color: 'text-emerald-400', bg: 'bg-emerald-500/10', label: 'Conversion' },
  fraud_alert: { icon: ShieldWarning, color: 'text-red-400', bg: 'bg-red-500/10', label: 'Fraud Alert' },
  notification: { icon: Bell, color: 'text-amber-400', bg: 'bg-amber-500/10', label: 'Notification' },
};

export default function LiveFeed({ events, connected }) {
  return (
    <div data-testid="live-feed" className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden">
      <div className="px-4 py-3 border-b border-zinc-800 flex items-center justify-between">
        <span className="text-sm font-heading font-medium text-white">Live Feed</span>
        <div className="flex items-center gap-2">
          <div className={`w-2 h-2 rounded-full ${connected ? 'bg-emerald-400 animate-pulse' : 'bg-zinc-600'}`} />
          <span className="text-[10px] text-zinc-500 uppercase tracking-wider">{connected ? 'Live' : 'Offline'}</span>
        </div>
      </div>
      <div className="max-h-64 overflow-y-auto">
        {events.length === 0 ? (
          <div className="p-6 text-center text-zinc-500 text-xs">Waiting for live events...</div>
        ) : (
          events.slice(0, 15).map((event, i) => {
            const cfg = typeConfig[event.type] || typeConfig.notification;
            const Icon = cfg.icon;
            const d = event.data || {};
            const time = d.timestamp ? new Date(d.timestamp).toLocaleTimeString() : new Date(event._ts).toLocaleTimeString();
            return (
              <div key={event._ts + '-' + i} className="px-4 py-2.5 border-b border-zinc-800/40 flex items-center gap-3 hover:bg-zinc-800/30 transition-colors" data-testid={`live-event-${i}`}>
                <div className={`w-7 h-7 rounded-lg ${cfg.bg} flex items-center justify-center shrink-0`}>
                  <Icon size={14} className={cfg.color} weight="duotone" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className={`text-[10px] font-bold uppercase tracking-wider ${cfg.color}`}>{cfg.label}</span>
                    {d.geo && <span className="text-[10px] text-zinc-600">{d.geo}</span>}
                  </div>
                  <p className="text-xs text-zinc-400 truncate">
                    {d.offer_title || d.title || d.details || 'Event'}
                    {d.revenue && <span className="text-emerald-400 ml-1">${d.revenue}</span>}
                  </p>
                </div>
                <span className="text-[10px] text-zinc-600 shrink-0">{time}</span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
